var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable prettier/prettier */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import NoPhotographyOutlinedIcon from "@mui/icons-material/NoPhotographyOutlined";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { ContainerLayout } from "../../components/ContainerLayout";
import { FixedMenu } from "../../components/FixedMenu";
import { FormButton, FormButtonType } from "../../components/FormButton";
import { CardCertidao } from "../../components/Habilitacao/CardCertidao";
import AppBarHeader from "../../components/Home/AppBarHeader";
import { Loading } from "../../components/Loading";
import { Modal } from "../../components/Modal";
import { NaoEncontrado } from "../../components/NaoEncontrado";
import { SnackbarFeedback } from "../../components/SnackbarFeedback";
import { ViewPdf } from "../../components/ViewPdf";
import { useAuth } from "../../hooks/useAuth";
import { obterGuiaPagamento } from "../../services/generico.service";
import { cancelarCertidaoCondutor, obterCertidaoCondutor, obterDadosCondutor, obterFoto, solicitarCertidaoCondutor, } from "../../services/habilitacao.service";
import { formatDate } from "../../util/formatadores";
import { Colors } from "../../util/theme";
export var CertidaoCondutor = function () {
    var userInfo = useAuth().userInfo;
    var _a = useState(), dados = _a[0], setDados = _a[1];
    var _b = useState(), certidao = _b[0], setCertidao = _b[1];
    var _c = useState(false), semCertidao = _c[0], setSemCertidao = _c[1];
    var _d = useState(false), modalNovaCertidao = _d[0], setModalNovaCertidao = _d[1];
    var _e = useState(false), modalCertidaoExistente = _e[0], setModalCertidaoExistente = _e[1];
    var _f = useState(), errorMessage = _f[0], setErrorMessage = _f[1];
    var _g = useState(true), loading = _g[0], setLoading = _g[1];
    var _h = useState(null), photoSrc = _h[0], setPhotoScr = _h[1];
    var _j = useState(undefined), base64 = _j[0], setBase64 = _j[1];
    var handleSubmit = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!dados) return [3 /*break*/, 5];
                    setLoading(true);
                    setErrorMessage(undefined);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    payload = {
                        numeroRegistro: dados.numeroRegistro,
                        dataNascimento: dados.dataNascimento,
                    };
                    return [4 /*yield*/, solicitarCertidaoCondutor(payload).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                            var boleto;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, obterGuiaPagamento(response.idDebito.toString())];
                                    case 1:
                                        boleto = _a.sent();
                                        setBase64(boleto.pdf);
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 2:
                    _d.sent();
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _d.sent();
                    setErrorMessage((_c = (_b = (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao realizar a solicitação da certidão de condutor");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setLoading(true);
                    setErrorMessage(undefined);
                    if (!certidao) return [3 /*break*/, 5];
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, cancelarCertidaoCondutor(certidao.codigoValidacao)];
                case 2:
                    _d.sent();
                    handleSubmit();
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _d.sent();
                    setErrorMessage((_c = (_b = (_a = error_2 === null || error_2 === void 0 ? void 0 : error_2.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao excluir a certidão de condutor");
                    return [3 /*break*/, 5];
                case 4:
                    setLoading(false);
                    setModalCertidaoExistente(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var fetchDados = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_3;
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 2, 3, 4]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                        };
                        return [4 /*yield*/, obterDadosCondutor(payload)];
                    case 1:
                        response = _d.sent();
                        setDados(response);
                        fetchFoto();
                        fetchCertidao();
                        return [3 /*break*/, 4];
                    case 2:
                        error_3 = _d.sent();
                        setErrorMessage((_c = (_b = (_a = error_3 === null || error_3 === void 0 ? void 0 : error_3.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.MensagemRetorno) !== null && _c !== void 0 ? _c : "Erro ao recuperar dados do condutor");
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        var fetchFoto = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(dados === null || dados === void 0 ? void 0 : dados.numeroRenach)) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        payload = {
                            cpf: userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username,
                            numeroRenach: dados.numeroRenach,
                        };
                        return [4 /*yield*/, obterFoto(payload)];
                    case 2:
                        response = _a.sent();
                        setPhotoScr(response.fotoBase64);
                        return [3 /*break*/, 5];
                    case 3:
                        error_4 = _a.sent();
                        console.error(error_4);
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        var fetchCertidao = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payload, response, error_5;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!dados) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        payload = {
                            numeroRegistro: dados.numeroRegistro,
                            dataNascimento: dados.dataNascimento,
                        };
                        return [4 /*yield*/, obterCertidaoCondutor(payload)];
                    case 2:
                        response = _b.sent();
                        setCertidao(response);
                        return [3 /*break*/, 5];
                    case 3:
                        error_5 = _b.sent();
                        if (error_5.response &&
                            error_5.response.data.MensagemRetorno ===
                                "Nenhuma certidão disponível para impressão.") {
                            setSemCertidao(true);
                        }
                        else {
                            setErrorMessage((_a = error_5.response.data.MensagemRetorno) !== null && _a !== void 0 ? _a : "Erro ao obter certidão do condutor");
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        fetchDados();
    }, [dados === null || dados === void 0 ? void 0 : dados.numeroRenach, userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username]);
    if (loading) {
        return (_jsxs(_Fragment, { children: [_jsx(AppBarHeader, { titulo: "Certid\u00E3o de condutor", voltarPara: "/home" }), _jsx(Loading, {})] }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(FixedMenu, { title: "Certid\u00E3o de condutor" }), _jsx(Box, __assign({ mt: { xs: "17rem", md: "13rem" } }, { children: _jsxs(ContainerLayout, { children: [_jsx(Stack, __assign({ flexDirection: "column", alignItems: "start", gap: "1rem", padding: "1rem", mb: "2rem", boxShadow: 2, sx: { backgroundColor: "white" } }, { children: _jsxs(Stack, __assign({ direction: { xs: "column", sm: "row" }, alignItems: { xs: "center", sm: "start" }, gap: "1rem", width: "100%" }, { children: [photoSrc ? (_jsx(Avatar, { src: "data:image/jpeg;base64,".concat(photoSrc), variant: "square", sx: { width: "10rem", height: "10rem" } })) : (_jsx(Avatar, __assign({ variant: "square", sx: { width: "10rem", height: "10rem" } }, { children: _jsx(NoPhotographyOutlinedIcon, { fontSize: "large" }) }))), _jsxs(Stack, __assign({ gap: "1rem", flexGrow: "1", alignItems: { xs: "center", sm: "start" } }, { children: [_jsx(Typography, __assign({ variant: "body1", fontSize: "1.375rem", fontWeight: "500" }, { children: dados === null || dados === void 0 ? void 0 : dados.nome })), _jsx(Stack, __assign({ sx: {
                                                    border: "1px solid ".concat(Colors.AZUL_GOV),
                                                    borderRadius: "2rem",
                                                    padding: "0.2rem 0.75rem",
                                                    textAlign: "center",
                                                }, width: { xs: '80%', sm: "50%" } }, { children: _jsxs(Typography, __assign({ variant: "body2", fontSize: "1rem", sx: { color: Colors.AZUL_GOV } }, { children: ["Validade CNH: ", formatDate(dados === null || dados === void 0 ? void 0 : dados.dataValidadeCnh)] })) })), _jsxs(Box, __assign({ display: "flex", justifyContent: "space-between", width: "100%", sx: { flexWrap: "wrap" } }, { children: [_jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "N\u00FAmero do Registro" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.numeroRegistro }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Categoria" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.categoriaCnh }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "RENACH" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.numeroRenach }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Data da Emiss\u00E3o" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.dataEmissao }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "UF de Emiss\u00E3o" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.ufEmissao }))] }), _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Pontua\u00E7\u00E3o" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.pontuacao }))] })] })), _jsx(Box, __assign({ display: "flex", justifyContent: "sta", width: "100%" }, { children: _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Ciretran do Processo" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.ultimaCiretranProcesso }))] }) })), _jsx(Box, __assign({ display: "flex", justifyContent: "sta", width: "100%" }, { children: _jsxs("div", { children: [_jsx(Typography, __assign({ variant: "body2", color: "textSecondary", fontSize: "1rem" }, { children: "Informa\u00E7\u00F5es Adicionais" })), _jsx(Typography, __assign({ variant: "body2", fontSize: "1rem" }, { children: dados === null || dados === void 0 ? void 0 : dados.listaObservacoesCnh }))] }) }))] }))] })) })), semCertidao && !certidao && (_jsx(NaoEncontrado, { title: errorMessage, subtitulo: "Nenhuma certid\u00E3o dispon\u00EDvel para impress\u00E3o.", noMargin: true })), certidao && _jsx(CardCertidao, { certidao: certidao }), _jsx(Stack, __assign({ my: "1rem" }, { children: _jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Solicitar nova certid\u00E3o", onClick: function () { return setModalNovaCertidao(true); } }) }))] }) })), _jsx(Modal, { open: modalNovaCertidao, onClose: function () { return setModalNovaCertidao(false); }, title: "Deseja solicitar uma nova certid\u00E3o?", subTitle: "Ao solicitar a certid\u00E3o de condutor, ser\u00E1 gerada um d\u00E9bito que dever\u00E1 ser quitado e compensado para que seja poss\u00EDvel a sua emiss\u00E3o?", buttons: [
                    _jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Sim", onClick: function () {
                            certidao ? setModalCertidaoExistente(true) : handleSubmit();
                            setModalNovaCertidao(false);
                        } }, 0),
                    _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "N\u00E3o", onClick: function () { return setModalNovaCertidao(false); } }, 1),
                ], directionButtons: "row-reverse" }), _jsx(Modal, { open: modalCertidaoExistente, onClose: function () { return setModalCertidaoExistente(false); }, title: "Aten\u00E7\u00E3o", subTitle: "Uma certid\u00E3o solicitada anteriormente ainda est\u00E1 armazenada. Deseja exclu\u00ED-la?", buttons: [
                    _jsx(FormButton, { type: FormButtonType.PRIMARY, title: "Sim", onClick: handleDelete }, 0),
                    _jsx(FormButton, { type: FormButtonType.SECONDARY, title: "N\u00E3o", onClick: function () { return setModalCertidaoExistente(false); } }, 1),
                ], directionButtons: "row-reverse" }), base64 && (_jsx(ViewPdf, { isOpen: !!base64, close: function () { return setBase64(undefined); }, base64: base64, title: "Certid\u00E3o do Condutor" })), errorMessage && (_jsx(SnackbarFeedback, { isOpen: !!errorMessage, message: errorMessage, type: "error" }))] }));
};
